import React from 'react'
import { PreDefinedFilters } from './treeManipulation/preDefinedFilters/PreDefinedFilters'
import { PreDefinedFilterTypes } from './treeManipulation/preDefinedFilters/utility'
import { Box } from '@mui/material'

export default function DeleteLeaves({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  return (
    <Box>
      <Box>Skill Leaf Operations</Box>
      <PreDefinedFilters
        treeId={treeId}
        versionId={versionId}
        filters={[
          PreDefinedFilterTypes.AllSkillLeaves,
          PreDefinedFilterTypes.DuplicateSkills,
        ]}
      />
    </Box>
  )
}
